export const availablityStatusTypes = {
	FAST_FILLING: 'Fast Filling',
	SOLD_OUT: 'Sold Out',
	AVAILABLE: 'Available',
	ALMOST_FULL: 'Almost Full',
	FILLING_FAST: 'Filling Fast',
	DO_NOT_COLOR: 'Do Not Color',
}
